/**
 *  functions.js
 *  Author: Sal
 *  Contains all ajax functions for the application
 */

import logo_ep from "../img/exampro-logo-white.svg";
import mobile_logo_ep from "../img/ico-osa-laptop.svg";
import logo_tb from "../img/logo-tb.png";
import ico_ep from "../img/ico-osa.svg";

const ax = require("axios");
let proxyUrl = "/proxy/proxy.php";
let dataUrl = "/proxy/getDetails.php";
let ssoUrl = "/proxy/checkSso.php";

if (window.location.host == 'localhost:3000' || window.location.host == 'dev.exampro.co.uk:3000' || window.location.host == 'testosa.exampro.co.uk') {
  proxyUrl = "https://testosa.exampro.co.uk/proxy/proxy.php";
  dataUrl = "https://testosa.exampro.co.uk/proxy/getDetails2.php";
  ssoUrl = "https://testosa.exampro.co.uk/proxy/checkSso.php";
}


//  check if logged in
//  @callback - function to pass the retrieved data
/**
 * Checks if the user is logged in by making an API call.
 * @param {Function} callback - Function to pass the retrieved data.
 */
const checkSession = (callback) => {

  const result = ax.create({
    withCredentials: true
  });

  result
    .post(proxyUrl, {
      type: "single",
      method: "checkSession",
      classname: "DbOsaLogin"
    })
    .then(data => {
      callback(data.data);
    })
    .catch((er) => {
      console.log(er);
    });
};

/**
 * Finds a center by its center number.
 * @param {string} centerNumber - The center ID to look up.
 * @param {Function} callback - Function to pass the retrieved data.
 */
const findCenter = (centerNumber, callback) => {

  const result = ax.create({
    withCredentials: true
  });

  result
    .post(proxyUrl, {
      type: "single",
      method: "findCenter",
      classname: "DbOsaLogin",
      params: [centerNumber]
    })
    .then(data => {
      callback(data.data);
    })
    .catch(er => {
      console.log(er);
    });
};


/**
 * Authenticates a user with username and password.
 * @param {string} username - The user's username.
 * @param {string} password - The user's password.
 * @param {Function} callback - Function to pass the retrieved data.
 */
const authenticate = (username, password, callback) => {

  const result = ax.create({
    withCredentials: true
  });

  result
    .post(proxyUrl, {
      type: "single",
      method: "authenticate",
      classname: "DbOsaLogin",
      params: [username, password]
    })
    .then(data => {
      callback(data.data);
    })
    .catch(er => {
      console.log(er);
    });
};

/**
 * Fetches student details and assignments using a filter.
 * @param {string} filterOne - The filter to use for fetching student details.
 * @param {Function} callback - Function to pass the retrieved data.
 */
const getStudentDetails = (filterOne, callback) => {
  checkSession(data => {
    if (!data.valid) {
      console.log(data);
      document.location.href = "https://osa.exampro.co.uk/portal/";
    } else {
      const result = ax.create({
        withCredentials: true
      });
      result
        .post(dataUrl, {
          type: "json",
          data: { 'filter': filterOne },
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(data => {
          callback(data.data);
        })
        .catch((er) => {
          console.log(er);
        });
    }
  });
};

/**
 * Gets the SSO (Single Sign-On) status for the current student.
 * @param {Function} callback - Function to pass the retrieved data.
 */
const getSsoStatus = (callback) => {

  const result = ax.create({
    withCredentials: true
  });

  result
    .get(ssoUrl, {
    })
    .then(data => {
      callback(data.data);
    })
    .catch((er) => {
      console.log(er);
    });
};

/**
 * Determines and returns the current brand (Exampro or Testbase) based on URL parameters.
 * Also sets a CSS class on the body for theming.
 * @returns {Object} Brand information including title, logo, favicon, and other properties.
 */
const getBrand = () => {
  let params = getUrlParams();
  let brandCase = "";
  let exp = false;
  let menu = 'home';
  if (params.menu) menu = params.menu;
  if (params.brand) {

    brandCase = params.brand.toLowerCase();
    if (params.experimental) exp = true;
  }
  if (brandCase !== "ep" && brandCase !== "tb") brandCase = "ep";

  let body = document.body;
  if (brandCase == 'tb') {

    //remove this and add the logic to the top of the application
    body.classList.add('theme-tb');

    return {
      title: "Testbase",
      logo: logo_tb,
      favicon: "https://app.doublestruck.eu/images/fav/TB.ico",
      key: brandCase,
      experimental: exp,
      navmenu: menu,
      studentLabel: "pupil",
      studentLabelCap: "Pupil",
      brand: "TB"
    };

  }

  if (brandCase == 'ep') {

    //remove this and add the logic to the top of the application
    body.classList.add('theme-ep');

    return {
      title: "Exampro",
      logo: logo_ep,
      mobileLogo: mobile_logo_ep,
      favicon: ico_ep,
      key: brandCase,
      experimental: exp,
      navmenu: menu,
      studentLabel: "student",
      studentLabelCap: "Student",
      brand: "EP"
    };
  }
};

/**
 * Parses the URL query string and returns an object of parameters.
 * @returns {Object|boolean} An object of URL parameters, or false if none exist.
 */
const getUrlParams = () => {
  const params = window.location.search;
  if (params) {
    const FIDQueryString = params
      .slice(1, params.length)
      .split("&")
      .reduce((prev, item) => {
        const paramResults = item.split("=");
        prev[paramResults[0]] = paramResults[1];
        return prev;
      }, {});
    return FIDQueryString;
  } else {
    return false;
  }
};

/**
 * Sets the favicon for the page to the provided image URL.
 * @param {string} img - Favicon image file link.
 */
const setFavicon = (img) => {
  let favicon = document.querySelector('link[rel="shortcut icon"]');
  let manifest = document.querySelector('link[rel="manifest"]');

  if (!favicon) {
    favicon = document.createElement("link");
    favicon.setAttribute("rel", "shortcut icon");
    document.head.appendChild(favicon);
  }

  if (!manifest) {
    manifest = document.createElement("link");
    manifest.setAttribute("rel", "manifest");
    manifest.setAttribute("href", "/manifest.json");
    document.head.appendChild(manifest);
  }

  favicon.setAttribute("type", "image/png");
  favicon.setAttribute("href", img);
};


export {
  authenticate,
  checkSession,
  getBrand,
  getUrlParams,
  findCenter,
  getStudentDetails,
  setFavicon,
  getSsoStatus
};